export const goToPageTracking = (
  _: 'search' | 'orders' | 'collections' | 'projects' | 'boards',
  linkPath?: string,
) => {
  if (linkPath) {
    window.location.href = linkPath;
  }
};
